import type { HTTPError } from "ky";

import { AjaxError } from "../AjaxError";

export class VisitorNotFoundException extends AjaxError {
  constructor(
    response: Response,
    request: Request,
    options: HTTPError["options"]
  ) {
    super(404, response, request, options, "Visitor not found");
    this.name = "VisitorNotFoundException";
  }
}
